export default "__VITE_ASSET__CqmoXxGU__"